// error messages
export const ErrorMessages = {
  NameEmpty: 'Please enter Name',
  PhoneEmpty: 'Please enter Phone Number',
  EmailEmpty: 'Please enter Email',
  EmailFormatIncorrect:'Please check email format',
  SelectLocation: 'Please select a location',
  CartEmpty: 'Please pick some product',
  SelectPickupTime: 'Please select a valid pickup time',
  PickupTimePassed: 'The pickup time is passed',
  OutOfWorkingHours: 'The pickup time is out of working hours',
  OutOfWorkingDays: 'It\' not open day'
}
